import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import prettyJoin from './pretty-joiner'

var PrettyRangeMultichoice = function(filter, meta) {
	let dateTimeOperator = _.camelCase(filter.dateTimeOperator)
	let labels
	if (!_.isEmpty(filter.metadata)) {
		//if a metadata object is given use it
		labels = _.map(filter.metadata, obj => i18n.get(obj.label || obj))
	} else {
		//otherwise look up via the choices on the meta object
		labels = _.map(filter.values, val => i18n.get(meta.choices()[val]) )
	}
	let args = [`report.filter.pretty.range.multichoice.${dateTimeOperator}`, prettyJoin(labels)]
		.concat(this.periodLabels(filter))
	return i18n.get.apply(i18n, args)
}

export default PrettyRangeMultichoice

PrettyRangeMultichoice.__filename__ = 'reports/common/filter/pretty-range-multichoice.js'
